import React, { useEffect, useState } from 'react';
import { useActiveSession } from './ActiveSessionContext';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase'; // adjust the path if needed
import { useAuth } from './AuthProvider'; // adjust path if needed
import dexie from './offlineDB';
import ActionConfirmModal from './components/ActionConfirmModal';
import { useLocation } from 'react-router-dom';

export default function SessionBanner() {
  const { activeSession: session, setActiveSession: setSession } = useActiveSession();
  const { user } = useAuth();
  const [showStopModal, setShowStopModal] = useState(false);
  const [navOffset, setNavOffset] = useState(52);
  const location = useLocation();
  const isFixedRoute = ['/add', '/social', '/settings'].some((route) => location.pathname.startsWith(route));

  useEffect(() => {
    const syncLayoutVars = () => {
      const navEl = document.querySelector('.nav-container');
      if (navEl) {
        const measured = Math.round(navEl.getBoundingClientRect().height || 52);
        setNavOffset(measured);
        document.body.style.setProperty('--session-nav-offset', `${Math.max(measured - 1, 0)}px`);
      }
    };

    document.body.classList.toggle('session-active', Boolean(session));
    document.body.classList.toggle('session-banner-fixed', Boolean(session) && isFixedRoute);
    syncLayoutVars();
    window.addEventListener('resize', syncLayoutVars);
    return () => {
      window.removeEventListener('resize', syncLayoutVars);
      document.body.classList.remove('session-active');
      document.body.classList.remove('session-banner-fixed');
      document.body.style.removeProperty('--session-nav-offset');
    };
  }, [session, isFixedRoute]);

  if (!session) return null;

  
const handleStop = async () => {
  try {
const ref = doc(db, 'users', user.uid, 'sessions', session.id);
const endedAt = new Date().toISOString(); // use ISO string as offline stand-in

if (navigator.onLine) {
  await updateDoc(ref, { endedAt: serverTimestamp() });
} else {
  await dexie.sessions.update(session.id, { endedAt });
  await dexie.pendingWrites.add({
    type: 'update',
    collection: 'sessions',
    docId: session.id,
    data: { endedAt }
  });
}

    } catch (err) {
      console.error('Failed to log session end:', err);
  }
  setSession(null);
};



  const isDark = document.body.classList.contains('theme-dark');

  return (
    <>
      <div
        style={{
        background: isDark ? '#333' : '#f5f5f5',
        color: isDark ? '#fff' : '#000',
        borderBottom: '1px solid #ccc',
        padding: '6px 16px',
        textAlign: 'center',
        fontSize: '14px',
        width: '100%',
        zIndex: 999,
        position: isFixedRoute ? 'fixed' : 'relative',
        top: isFixedRoute ? `${Math.max(navOffset - 1, 0)}px` : 'unset',
        left: isFixedRoute ? 0 : 'unset',
        right: isFixedRoute ? 0 : 'unset',
        marginTop: isFixedRoute ? 0 : `${Math.max(navOffset - 1, 0)}px`
      }}
      >
        🟢 Active session: <strong>{session.location}</strong> — <em>{new Date(session.startedAt).toLocaleString()}</em>
        <button
          onClick={() => setShowStopModal(true)}
          className="btn-subtle action-confirm-danger"
          style={{ marginLeft: '14px' }}
        >
          Stop Session
        </button>
      </div>
      <ActionConfirmModal
        open={showStopModal}
        title="End Session"
        message="End the current session?"
        confirmLabel="End Session"
        cancelLabel="Keep Session"
        danger
        onConfirm={async () => {
          setShowStopModal(false);
          await handleStop();
        }}
        onCancel={() => setShowStopModal(false)}
      />
    </>
  );
}
